import { useState, useEffect } from 'react';

import { tabController } from '../../../../Components/utils/functions';

import Settings from './Settings/Settings';
import Style from '../Common/Style';
import SocialShare from './SocialShare';

const Edit = props => {
	const { className, attributes, setAttributes, clientId, isSelected } = props;

	useEffect(() => tabController(), [isSelected]);

	const [activeIndex, setActiveIndex] = useState(0);

	const id = `bssbSocialShare-${clientId}`;

	return <>
		<Settings attributes={attributes} setAttributes={setAttributes} activeIndex={activeIndex} setActiveIndex={setActiveIndex} />

		<div className={className} id={id}>
			<Style attributes={attributes} id={id} />

			<SocialShare attributes={attributes} isBackend={true} custom={{ activeIndex, setActiveIndex }} />
		</div>
	</>;
};
export default Edit;